import { useSelector } from "react-redux";

import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { ALL_OFFICER } from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import OfficerList from "../components/officerList/OfficerList";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";

const OfficersPage = () => {
  const {isLoaded } = useFetchData(ALL_OFFICER);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  return (
    <MainPageLayout
      headerConfig={{ title: "Officers" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <OfficerList officersData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default OfficersPage;
